import React from 'react';
import PropTypes from 'prop-types';
import { withContainer } from 'core/cache';

import { getMockCredential } from '../helpers/getMockData';

import CredentialModal from '../components/credentialModal';

const CredentialModalContainer = ({ credentialModal, gamification }) => {
  const {
    data: {
      credential,
      reputation_earned: reputationEarned,
      user_credential: userCredential,
      gold_earned: goldEarned,
    },
  } = credentialModal;

  return (
    <CredentialModal
      credential={credential}
      reputationEarned={reputationEarned}
      userCredential={userCredential}
      gamification={gamification.data}
      goldEarned={goldEarned}
      isLoading={credentialModal.status !== 'success'}
      isShareable
    />
  );
};

CredentialModalContainer.propTypes = {
  credentialModal: PropTypes.shape({
    data: PropTypes.shape({
      credential: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        allow_sharing: PropTypes.bool,
        badge_absolute_url: PropTypes.string,
        created_at: PropTypes.string,
        credential_type: PropTypes.string,
        credly_badge_template_key: PropTypes.string,
        description: PropTypes.string,
      }),
      reputation_earned: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          reputation_points: PropTypes.number,
        })
      ),
      user_credential: PropTypes.shape({
        id: PropTypes.number,
        user_id: PropTypes.number,
        account_id: PropTypes.number,
        expires_on: PropTypes.string,
        created_at: PropTypes.string,
        has_user_been_notified: PropTypes.bool,
        completion_id: PropTypes.number,
        access_token: PropTypes.string,
        credly_badge_key: PropTypes.string,
        reputation_points: PropTypes.number,
        score: PropTypes.number,
      }),
      gold_earned: PropTypes.number,
    }).isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  gamification: PropTypes.shape({
    data: PropTypes.shape({
      is_gold_enabled: PropTypes.bool,
      gold_redeem_url: PropTypes.string,
      has_reached_gold_limit: PropTypes.bool,
      gold_balance: PropTypes.number,
    }).isRequired,
  }).isRequired,
};

export default withContainer(CredentialModalContainer, {
  cache: {
    credentialModal: {
      getMockedResponse: () => ({ data: getMockCredential() }),
      getParams: ({ props }) => ({ id: props.id }),
      initialData: {},
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/learner/profile_credentials/:id',
    },
  },
});
